import { createTheme } from "@mui/material";
import { green, purple } from "@mui/material/colors";

let theme = createTheme({
  palette: {
    primary: {
      main: "#000000",
    },
    secondary: {
      main: "#E0C2FF",
      light: "lightgrey",
      dark: "#47009F",
      contrastText: "#47008F",
    },
  },
});

theme = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        root: ({ theme }) => ({
          // use JavaScript conditional expression
          color:
            theme.palette.mode === "dark" ? "#fff" : theme.palette.primary.main,
          minHeight: "50px",
        }),
      },
    },
    MuiListItemText: {
      styleOverrides: {
        primary: {
          color: "red",
        },
      },
    },
  },
  palette: {
    primary: {
      main: purple[500],
    },
    secondary: {
      main: green[500],
    },
  },
});

theme = createTheme({
  typography: {
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    h3: {
      fontSize: "1.2rem",
      "@media (min-width:600px)": {
        fontSize: "1.5rem",
      },
      [theme.breakpoints.up("md")]: {
        fontSize: "2.4rem",
      },
    },
    subtitle: {},
    body: {
      //   Usage: <Typography variant="subtitle1">subtitle</Typography>
    },
  },
});

export default theme;
